import ExpandMore from '@mui/icons-material/ExpandMore';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { selectSx } from './OpenXAgentSelect.styles.ts';
import { popoverSx } from './utils/styles.ts';

export type OpenXAgentSelectOption<T extends string> = {
  value: T;
  label: string;
};

type OpenXAgentSelectProps<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
  dataTest: string;
  options: OpenXAgentSelectOption<T>[];
  placeholder?: string;
};

export const OpenXAgentSelect = <T extends string>({
  value,
  onChange,
  ariaLabel,
  dataTest,
  options,
  placeholder,
}: OpenXAgentSelectProps<T>) => (
  <Select<T>
    value={value}
    onChange={event => onChange(event.target.value as T)}
    {...(!!placeholder && {
      displayEmpty: true,
      renderValue: selected => (selected ? options.find(option => option.value === selected)?.label : placeholder),
    })}
    // the default "outlined" variant makes displayEmpty forward `notched` to the bare InputBase
    variant="standard"
    input={<InputBase />}
    inputProps={{ 'aria-label': ariaLabel }}
    IconComponent={ExpandMore}
    MenuProps={{ sx: popoverSx }}
    data-test={dataTest}
    sx={selectSx}
  >
    {options.map(option => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </Select>
);
